/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddFavoriteDto } from '../models/AddFavoriteDto';
import type { AddFavoriteResponse } from '../models/AddFavoriteResponse';
import type { ClientNearSectorResponse } from '../models/ClientNearSectorResponse';
import type { CreateGalleryImageDto } from '../models/CreateGalleryImageDto';
import type { CreateSocietyDto } from '../models/CreateSocietyDto';
import type { FollowingDistributorResponse } from '../models/FollowingDistributorResponse';
import type { FollowingInstallerResponse } from '../models/FollowingInstallerResponse';
import type { GalleryImageResponse } from '../models/GalleryImageResponse';
import type { InstallerInRangeResponse } from '../models/InstallerInRangeResponse';
import type { MessageResponse } from '../models/MessageResponse';
import type { OnboardingStatusResponse } from '../models/OnboardingStatusResponse';
import type { ResubmitDocumentDto } from '../models/ResubmitDocumentDto';
import type { SectorResponse } from '../models/SectorResponse';
import type { SocietyDetailResponse } from '../models/SocietyDetailResponse';
import type { SocietyHomeResponse } from '../models/SocietyHomeResponse';
import type { SocietyProfileResponse } from '../models/SocietyProfileResponse';
import type { SocietyResponse } from '../models/SocietyResponse';
import type { UpdateGalleryImageDto } from '../models/UpdateGalleryImageDto';
import type { UpdateSocietyDto } from '../models/UpdateSocietyDto';
import type { ValidateSocietyDto } from '../models/ValidateSocietyDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SocietiesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a society
     * Create a new society. Only users with SOCIETY_OWNER role can create societies.
     * @returns SocietyResponse Society created successfully.
     * @throws ApiError
     */
    public societiesControllerCreate({
        requestBody,
    }: {
        requestBody: CreateSocietyDto,
    }): CancelablePromise<SocietyResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/societies',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER role required.`,
            },
        });
    }
    /**
     * List societies
     * Returns a paginated list of societies. Non-admin users only see VALIDATED societies. Admin users can filter by status.
     * @returns any List of societies.
     * @throws ApiError
     */
    public societiesControllerFindAll({
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
        type,
        status,
        search,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Field to sort by
         */
        sortBy?: string,
        /**
         * Sort order (asc/desc)
         */
        sortOrder?: 'asc' | 'desc',
        /**
         * Filter by society type
         */
        type?: 'SECURITY' | 'INSTALLER' | 'DISTRIBUTOR',
        /**
         * Filter by society status (admin only)
         */
        status?: 'PENDING' | 'WAITING_ON_INFORMATION' | 'VALIDATED' | 'REJECTED',
        /**
         * Search by name or email
         */
        search?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies',
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'type': type,
                'status': status,
                'search': search,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Search societies
     * Search validated societies by name, email, or description. Optionally filter by type (INSTALLER or DISTRIBUTOR).
     * @returns SocietyResponse Search results returned.
     * @throws ApiError
     */
    public societiesControllerSearch({
        q,
        type,
    }: {
        /**
         * Search query
         */
        q?: string,
        /**
         * Filter by society type
         */
        type?: 'SECURITY' | 'INSTALLER' | 'DISTRIBUTOR',
    }): CancelablePromise<Array<SocietyResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/search',
            query: {
                'q': q,
                'type': type,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Get installers covering a location
     * Returns VALIDATED INSTALLER societies that have at least one sector whose rangeKm covers the given coordinates. Pass the selected client location's latitude/longitude.
     * @returns InstallerInRangeResponse List of installer societies covering the location.
     * @throws ApiError
     */
    public societiesControllerFindInstallersInRange({
        latitude,
        longitude,
    }: {
        /**
         * Latitude of the search center
         */
        latitude: string,
        /**
         * Longitude of the search center
         */
        longitude: string,
    }): CancelablePromise<Array<InstallerInRangeResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/installers-in-range',
            query: {
                'latitude': latitude,
                'longitude': longitude,
            },
            errors: {
                400: `Invalid latitude/longitude values.`,
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Get followed installers
     * Returns validated INSTALLER societies that the authenticated distributor has favorited, with optional proximity sorting.
     * @returns FollowingInstallerResponse List of followed installer societies.
     * @throws ApiError
     */
    public societiesControllerFindFollowingInstallers({
        latitude,
        longitude,
    }: {
        /**
         * Latitude for proximity sorting
         */
        latitude?: string,
        /**
         * Longitude for proximity sorting
         */
        longitude?: string,
    }): CancelablePromise<Array<FollowingInstallerResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/following-installers',
            query: {
                'latitude': latitude,
                'longitude': longitude,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER role required.`,
            },
        });
    }
    /**
     * Get followed distributors
     * Returns validated DISTRIBUTOR societies that the authenticated installer has favorited, with optional proximity sorting.
     * @returns FollowingDistributorResponse List of followed distributor societies.
     * @throws ApiError
     */
    public societiesControllerFindFollowingDistributors({
        latitude,
        longitude,
    }: {
        /**
         * Latitude for proximity sorting
         */
        latitude?: string,
        /**
         * Longitude for proximity sorting
         */
        longitude?: string,
    }): CancelablePromise<Array<FollowingDistributorResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/following-distributors',
            query: {
                'latitude': latitude,
                'longitude': longitude,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER role required.`,
            },
        });
    }
    /**
     * Get society public profile
     * Returns a public profile view of a society with sectors and agents. Sensitive fields like document URLs, owner ID, and agent verification statuses are excluded. Any authenticated user can access this endpoint.
     * @returns SocietyProfileResponse Society public profile returned.
     * @throws ApiError
     */
    public societiesControllerGetProfile({
        id,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
    }): CancelablePromise<SocietyProfileResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{id}/profile',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Get society detail
     * Returns a society with its sectors, agents, and sensitive fields (document URLs, verification statuses). Only accessible by admins and the society owner.
     * @returns SocietyDetailResponse Society found.
     * @throws ApiError
     */
    public societiesControllerFindOne({
        id,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
    }): CancelablePromise<SocietyDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not the society owner or admin.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Update society
     * Update a society. Only the owner or an admin can update.
     * @returns SocietyResponse Society updated successfully.
     * @throws ApiError
     */
    public societiesControllerUpdate({
        id,
        requestBody,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
        requestBody: UpdateSocietyDto,
    }): CancelablePromise<SocietyResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/societies/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Delete society
     * Delete a society and all associated data (cascade). Only the owner or an admin can delete.
     * @returns MessageResponse Society deleted successfully.
     * @throws ApiError
     */
    public societiesControllerRemove({
        id,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/societies/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Validate or reject society (Admin)
     * Admin endpoint to validate or reject a society. A reason is required when rejecting.
     * @returns SocietyResponse Society validation updated.
     * @throws ApiError
     */
    public societiesControllerValidate({
        id,
        requestBody,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
        requestBody: ValidateSocietyDto,
    }): CancelablePromise<SocietyResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/societies/{id}/validate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Reason required for rejection.`,
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Resubmit a rejected society document
     * Allows the society owner to resubmit a document that was previously denied or not uploaded. The document status is reset to PENDING for admin review. If the society is in WAITING_ON_INFORMATION status and all required documents are now complete, the society is automatically transitioned back to PENDING.
     * @returns SocietyResponse Document resubmitted successfully. Status reset to PENDING.
     * @throws ApiError
     */
    public societiesControllerResubmitDocument({
        id,
        requestBody,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
        requestBody: ResubmitDocumentDto,
    }): CancelablePromise<SocietyResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/societies/{id}/documents/resubmit',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error. Document type not applicable, already validated, or already pending.`,
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * List society sectors
     * Returns all sectors belonging to a society.
     * @returns SectorResponse List of sectors.
     * @throws ApiError
     */
    public societiesControllerGetSectors({
        id,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
    }): CancelablePromise<Array<SectorResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{id}/sectors',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Get society onboarding status
     * Returns the current onboarding step and what is needed next. Computed from profile completeness, document status, wallet, and sectors. Only the society owner or admin can access.
     * @returns OnboardingStatusResponse Onboarding status.
     * @throws ApiError
     */
    public societiesControllerGetOnboardingStatus({
        id,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
    }): CancelablePromise<OnboardingStatusResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{id}/onboarding-status',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Get society document validation status
     * Returns the document validation status for a society. Used by the frontend to show badge indicators and determine if the society can use the app. Shows whether documents are pending, rejected, or validated.
     * @returns any Document validation status.
     * @throws ApiError
     */
    public societiesControllerGetDocumentStatus({
        id,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
    }): CancelablePromise<{
        societyId?: string;
        societyStatus?: string;
        canUseApp?: boolean;
        hasPendingDocuments?: boolean;
        hasRejectedDocuments?: boolean;
        documents?: Array<{
            type?: string;
            status?: string;
            statusDescription?: string;
        }>;
        agentDocumentStatus?: Array<{
            agentId?: string;
            firstName?: string;
            lastName?: string;
            status?: string;
            proCardStatus?: string;
            idCardStatus?: string;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{id}/document-status',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Get clients near society sectors
     * Returns clients that have locations within the coverage area of the society sectors. Only the society owner or admin can access.
     * @returns ClientNearSectorResponse List of clients near society sectors.
     * @throws ApiError
     */
    public societiesControllerGetClients({
        id,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
    }): CancelablePromise<Array<ClientNearSectorResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{id}/clients',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Get society home dashboard
     * Returns the home screen data for a society owner: agent counts (online/total), active interventions count, balance, and list of in-progress interventions with agent and location details.
     * @returns SocietyHomeResponse Society home dashboard data.
     * @throws ApiError
     */
    public societiesControllerGetHome({
        id,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
    }): CancelablePromise<SocietyHomeResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{id}/home',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Get clients who favorited this installer
     * Returns a list of clients who have set this society as their favorite installer. Only the society owner or admin can access.
     * @returns any List of clients who favorited this installer.
     * @throws ApiError
     */
    public societiesControllerGetFavoriteClients({
        id,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{id}/favorite-clients',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Add society to favorites
     * Adds a society to the authenticated owner's favorites list. Supports both DISTRIBUTOR→INSTALLER and INSTALLER→DISTRIBUTOR directions. The owner must own a DISTRIBUTOR or INSTALLER society, and the target must be a validated society of the opposite type.
     * @returns AddFavoriteResponse Installer added to favorites successfully.
     * @throws ApiError
     */
    public societiesControllerAddFavorite({
        id,
        requestBody,
    }: {
        /**
         * Owner society unique identifier
         */
        id: string,
        requestBody: AddFavoriteDto,
    }): CancelablePromise<AddFavoriteResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/societies/{id}/favorites',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER role required.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Remove society from favorites
     * Removes a society from the owner's favorites list. Works for both distributor and installer favorites. Only the society owner can remove their own favorites.
     * @returns MessageResponse Favorite removed successfully.
     * @throws ApiError
     */
    public societiesControllerRemoveFavorite({
        favoriteId,
        id,
    }: {
        /**
         * SocietyFavorite unique identifier
         */
        favoriteId: string,
        /**
         * Society unique identifier
         */
        id: any,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/societies/{id}/favorites/{favoriteId}',
            path: {
                'favoriteId': favoriteId,
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Favorite not found.`,
            },
        });
    }
    /**
     * Add gallery image
     * Add a new image to the society gallery. Only the society owner or an admin can add images.
     * @returns GalleryImageResponse Gallery image added successfully.
     * @throws ApiError
     */
    public societiesControllerAddGalleryImage({
        id,
        requestBody,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
        requestBody: CreateGalleryImageDto,
    }): CancelablePromise<GalleryImageResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/societies/{id}/gallery',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * List society gallery images
     * Returns all gallery images for a society. Any authenticated user can access.
     * @returns GalleryImageResponse List of gallery images.
     * @throws ApiError
     */
    public societiesControllerGetGalleryImages({
        id,
    }: {
        /**
         * Society unique identifier
         */
        id: string,
    }): CancelablePromise<Array<GalleryImageResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{id}/gallery',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Get gallery image
     * Returns a single gallery image by its unique identifier.
     * @returns GalleryImageResponse Gallery image found.
     * @throws ApiError
     */
    public societiesControllerGetGalleryImage({
        galleryId,
    }: {
        /**
         * Gallery image unique identifier
         */
        galleryId: string,
    }): CancelablePromise<GalleryImageResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/societies/{galleryId}/gallery-image',
            path: {
                'galleryId': galleryId,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Gallery image not found.`,
            },
        });
    }
    /**
     * Update gallery image
     * Update a gallery image. Only the society owner or an admin can update.
     * @returns GalleryImageResponse Gallery image updated successfully.
     * @throws ApiError
     */
    public societiesControllerUpdateGalleryImage({
        galleryId,
        requestBody,
    }: {
        /**
         * Gallery image unique identifier
         */
        galleryId: string,
        requestBody: UpdateGalleryImageDto,
    }): CancelablePromise<GalleryImageResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/societies/{galleryId}/gallery-image',
            path: {
                'galleryId': galleryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Gallery image not found.`,
            },
        });
    }
    /**
     * Delete gallery image
     * Delete a gallery image. Only the society owner or an admin can delete.
     * @returns MessageResponse Gallery image deleted successfully.
     * @throws ApiError
     */
    public societiesControllerRemoveGalleryImage({
        galleryId,
    }: {
        /**
         * Gallery image unique identifier
         */
        galleryId: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/societies/{galleryId}/gallery-image',
            path: {
                'galleryId': galleryId,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Gallery image not found.`,
            },
        });
    }
}
